import React, { FC } from 'react';
import styles from './index.module.scss';
import { Alert } from 'src/common';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';
import { useTranslation } from 'react-i18next';
import { Header } from 'src/shared';
import { TaskNavProvider } from 'src/models/bids/BidTask/providers';
import TaskPageContainer from './TaskPageContainer';

export const TaskPage: FC = () => {
  const { t } = useTranslation();
  const isBidFlowFeature = useFeatureFlag(FeatureFlag.BiddingWorkflow_Tasks);

  return isBidFlowFeature ? (
    <>
      <Header />
      <div className={styles.page}>
        <TaskNavProvider>
          <TaskPageContainer />
        </TaskNavProvider>
      </div>
    </>
  ) : (
    <Alert message={t('Common.ACL.noAccessFeature')} type={'info'} />
  );
};

export default TaskPage;
